import axiosClient from '@/api/axiosClient';

export interface TableCommentResponse {
  commentId: string;
  comment: string;
  timeStamp: string;
  lastEdit?: string | null;
  isEdited: boolean;
  editedBy?: string | null;
  userName: string;
  isImported: boolean;
  importedBy?: string | null;
  isDeleted: boolean;
  deletedTime?: string | null;
  deletedBy?: string | null;
  hasError: boolean;
}

export interface TableCommentThreadResponse {
  comments: TableCommentResponse[];
}

export interface CreateTableCommentRequest {
  rowId: number;
  columnKey: string;
  comment: string;
}

export interface UpdateTableCommentRequest {
  rowId: number;
  columnKey: string;
  commentId: string;
  comment: string;
}

export interface DeleteTableCommentRequest {
  rowId: number;
  columnKey: string;
  commentId: string;
}

export async function createTableComment (
  tableKeyOrId: string | number,
  body: CreateTableCommentRequest
): Promise<TableCommentThreadResponse> {
  const tableRef = String(tableKeyOrId ?? '').trim();
  const { data } = await axiosClient.post<TableCommentThreadResponse>(
    `v2/table/${tableRef}/rows/comment`,
    body
  );
  return data;
}

export async function updateTableComment (
  tableKeyOrId: string | number,
  body: UpdateTableCommentRequest
): Promise<TableCommentThreadResponse> {
  const tableRef = String(tableKeyOrId ?? '').trim();
  const { data } = await axiosClient.put<TableCommentThreadResponse>(
    `v2/table/${tableRef}/rows/comment`,
    body
  );
  return data;
}

export async function deleteTableComment (
  tableKeyOrId: string | number,
  body: DeleteTableCommentRequest
): Promise<TableCommentThreadResponse> {
  const tableRef = String(tableKeyOrId ?? '').trim();
  const { data } = await axiosClient.delete<TableCommentThreadResponse>(
    `v2/table/${tableRef}/rows/comment`,
    { data: body }
  );
  return data;
}
